import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/styles';
import { Field, reduxForm } from 'redux-form';
import Button from 'components/buttons/Button';
import Cross from 'icons/cross';
import { requiredValidator, emailValidator } from 'utils/validators';
import RenderFormInput from 'components/forms/RenderFormInput';

const styles = theme => ({
  formWrapper: {
    backgroundColor: theme.palette.white,
    width: '558px',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '8px',
    boxShadow: theme.shadows[3],
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
  },
  title: {
    color: theme.palette.secondary.text,
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '-0.2px',
    lineHeight: '20px',
  },
  closeIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  formBody: {
    padding: '24px',
  },
  sectionDescription: {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0',
    marginBottom: '16px',
  },
  sectionDescriptionBold: {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.2px',
    fontWeight: '600',
    marginBottom: '16px',
  },
  formLabel: {
    display: 'inline-block',
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '0',
    lineHeight: '16px',
    marginBottom: '6px',
    color: theme.palette.gray.dark,
  },
  forgotPasswordText: {
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0',
    color: theme.palette.secondary.text,
  },
  forgotPasswordLink: {
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0',
    fontWeight: '600',
    color: theme.palette.secondary.text,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '24px',
  },
});

class UpdateEmailModal extends PureComponent {
  closeModal = () => {
    this.props.reset();
    this.props.toggleEmailModal();
  }

  render() {
    const { classes, user, handleSubmit } = this.props;
    return (
      <form className={classes.formWrapper} onSubmit={handleSubmit}>
        <div className={classes.header}>
          <span className={classes.title}>Update Email</span>
          <Cross className={classes.closeIcon} onClick={this.closeModal} />
        </div>
        <hr style={{ margin: '0' }} />
        <div className={classes.formBody}>
          <div>
            <span className={classes.sectionDescription}>Your current account email: </span>
            <span className={classes.sectionDescriptionBold}>{user.email}</span>
          </div>
          <div className="form__form-group mt-3">
            <span className={classes.formLabel}>New Email</span>
            <div className="form__form-group-field">
              <Field
                name="email"
                component={RenderFormInput}
                type="email"
                label="Enter email"
                validate={[requiredValidator, emailValidator]}
              />
            </div>
          </div>
          <div style={{ marginTop: '24px' }}>
            <span className={classes.sectionDescription}>
              Please verify password in order to change account email
            </span>
          </div>
          <div className="form__form-group mt-3">
            <span className={classes.formLabel}>Current Password</span>
            <div className="form__form-group-field">
              <Field
                name="password"
                component={RenderFormInput}
                type="password"
                label="Enter password"
                minlength="9"
                maxlength="250"
                validate={[requiredValidator]}
              />
            </div>
          </div>
          <div className="mt-2">
            <span className={classes.forgotPasswordText}>Forgot your password? </span>
            <a className={classes.forgotPasswordLink} href="/forgot">Reset</a>
          </div>
        </div>
        <hr style={{ margin: '0' }} />
        <div className={classes.footer}>
          <Button
            size="medium"
            variant="textSecondary"
            onClick={this.closeModal}
            style={{ marginRight: '16px' }}
          >
            Cancel
          </Button>
          <Button
            variant="containedPrimaryCTA"
            size="medium"
            type="submit"
          >
            Save
          </Button>
        </div>
      </form>
    );
  }
}

UpdateEmailModal.propTypes = {
  classes: PropTypes.element.isRequired,
  toggleEmailModal: PropTypes.func.isRequired,
  user: PropTypes.element.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, { withTheme: true }),
  reduxForm({
    form: 'update_email_form', // a unique identifier for this form
  }),
  connect(state => ({
    user: state.user,
  })),
)(UpdateEmailModal);
